import { Component, inject, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Admin } from '../../../../../services/admin';
import { Auth } from '../../../../../services/auth';
import { Buyer } from '../../../../../services/buyer';
import { Location } from '@angular/common';
import { formatDate } from '@angular/common';
import { Country } from 'country-state-city';
import { NavStateService } from '../../../../../services/nav-state.service';
import { SuccessDialog } from '../../../../common-features/success-dialog/success-dialog';

@Component({
  selector: 'app-update-requirement',
  standalone: false,
  templateUrl: './update-requirement.html',
  styleUrl: './update-requirement.less'
})
export class UpdateRequirement implements OnInit{

  private route = inject(ActivatedRoute);
  private formBuilder = inject(FormBuilder);
  private authService = inject(Auth);
  private buyerServive = inject(Buyer);
  private adminService = inject(Admin);
  private router = inject(Router);
  private location = inject(Location); 
  private matDialog=inject(MatDialog);
   private navState = inject(NavStateService);
  article:any;
  articleImage:any;
  modalText:any;
  modalTitle:any;
  req:any;
  user:any;
  createRequirement!:FormGroup;
  submitted:boolean = false;
  currency:any[]=['$','Euro','INR'];
  uomDropDown=['Box','Tray','Pallet','Punnet','Pc','Crate','Carton','Container'];
  incoterms: any[] = ['FOB', 'CIF', 'DDP', 'EX-WORKS'];
  routeList=['Air','Sea','Land'];
  public data: any;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public modalData:any,
  @Optional() public matDialogRef: MatDialogRef<UpdateRequirement>,
){
    this.data = this.modalData || history.state.data;
    this.createRequirement = this.formBuilder.group({
      buyingPrice:['',Validators.required],
      quantity:['',Validators.required],
      uom:['',Validators.required],
      longTermContract:[],
      periodicity:[''],
      shipmentQuantity:[0],
      currency:['',Validators.required],
      processNote:[''],
      totalPrice:[''],
      destinationPort:['',Validators.required],
      eta:[,Validators.required],
      incoterms:['',Validators.required],
      route:[''],
    });

    this.authService.user.subscribe((x:any)=>this.user =x)
  }

  ngOnInit(): void {
    this.navState.setCurrentTitle(`Update Requirement`);
    this.navState.setShowBackButton(true);
    if (!this.data) {
      this.location.back();
      return;
    }
   console.log(this.data);
    this.article = this.data.article;
    console.log(this.article);
    if(this.article.articleImage !=null){
      this.getMediaFile();
    }
    this.createRequirement.patchValue(this.data);
    this.createRequirement.patchValue({
      totalPrice:this.data.currency +
      ' ' +
      this.data.quantity *
        this.data.buyingPrice
    })
  
    this.createRequirement.patchValue({
      eta: formatDate(this.data.eta, 'yyyy-MM-dd', 'en')
    });
  }

  getMediaFile(){

    this.adminService.getMediaById(this.article.articleImage).subscribe({
      next: (data: Blob) => {
        const reader = new FileReader();
        reader.onload = (e: any) => this.articleImage = e.target.result;
        reader.readAsDataURL(data);
      },
      error: (err) => {
        console.error(err);
      }
    });
    
  }

  submitRequirement(){  
    this.submitted = true;
    if(this.createRequirement.invalid){
      // alert('invalid');
      return
    }else{
    const updateRequirement={
          ...this.data,
        
          quantity: this.createRequirement.value.quantity,
          uom: this.createRequirement.value.uom,
          processNote:this.createRequirement.value.processNote,
          longTermContract:this.createRequirement.value.longTermContract,
          shipmentQuantity:this.createRequirement.value.shipmentQuantity,
          periodicity:this.createRequirement.value.periodicity,
          buyingPrice: this.createRequirement.value.buyingPrice,
          currency: this.createRequirement.value.currency,
          eta:this.createRequirement.value.eta,
          incoterms:this.createRequirement.value.incoterms,
          route:this.createRequirement.value.route,
          // destinationPort:this.createRequirement.value.destination,
          // conversations:[],
         // article:this.article,
          //sourcePort:''
        
      }

     

      this.buyerServive.patchRequirement(updateRequirement,this.data.id)
      .subscribe({
        next: (data: any) => {
          console.log(data);
          this.modalText= data.message,
          this.modalTitle='SUCCESS'
          this.submitted = false;
          this.showSuccessAndErrorDialog(this.modalTitle,this.modalText,'success')
         
        },
        error: (error: any) => {
          console.log(error);
            this.modalText= 'Error in creating the requirement.Please contact admin',
          this.modalTitle='ERROR';
          this.showSuccessAndErrorDialog(this.modalTitle,this.modalText,'error')
         
          this.submitted = false;
        }
      })
    }

  }

  moveTo() {
    this.router.navigate(['/buyer-catalog']);
  }

  goBack() {
    this.location.back();
  }
  close(){
    if (this.matDialogRef) {
      this.matDialogRef.close();
    } else {
      this.location.back();
    }
  }
  

  setLongTermContractToggleValue() {
    const value = this.createRequirement.get('longTermContract')?.value;
    if (value) {
      this.createRequirement.get('periodicity')?.enable();
    } else {
      this.createRequirement.get('periodicity')?.disable();
    }
  }
  
 
  showSuccessAndErrorDialog(modalTitle:any,modalText:any,icon:string){
    const dialog = this.matDialog.open(SuccessDialog,{
      disableClose:true,
      width:'500px',
      data:{
        modalTitle:modalTitle,
        modalText:modalText,
        icon:icon
      }
    })
    dialog.afterClosed().subscribe(result=>{
      this.close();
    })
   
  }

  getCountryFlag(origin: string) {
      if (!origin) return `https://flagcdn.com/w20/un.png`;
  
      const manualMap: { [key: string]: string } = {
          'dubai': 'ae',
          'uae': 'ae',
          'uk': 'gb',
          'usa': 'us',
          'united states': 'us'
      };
  
      const normalized = origin.trim().toLowerCase();
      if (manualMap[normalized]) {
          return `https://flagcdn.com/w20/${manualMap[normalized]}.png`;
      }
  
      // Dynamic search
      const allCountires = Country.getAllCountries();
      const country = allCountires.find(c => c.name.toLowerCase() === normalized) ||
          allCountires.find(c => c.name.toLowerCase().includes(normalized));
  
      const code = country ? country.isoCode.toLowerCase() : 'un';
      return `https://flagcdn.com/w20/${code}.png`;
    }


}

